// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"vendors-node_modules_dompurify_dist_purify_es_mjs":"d7eb628c6d91ecb6","vendors-node_modules_canvg_lib_index_es_js":"9c089e24a9f06402"}[chunkId] + ".js";
};